export const items = [
  { label: "فروردین", value: "FARVARDIN" },
  { label: "اردیبهشت", value: "ORDIBEHESHT" },
  { label: "خرداد", value: "KHORDAD" },
  { label: "تیر", value: "TIR" },
  { label: "مرداد", value: "MORDAD" },
  { label: "شهریور", value: "SHAHRIVAR" },
  { label: "مهر", value: "MEHR" },
  { label: "آبان", value: "ABAN" },
  { label: "آذر", value: "AZAR" },
  { label: "دی", value: "DEY" },
  { label: "بهمن", value: "BAHMAN" },
  { label: "اسفند", value: "ESFAND" },
];
